import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQ5wn_tlgcvCsKW7R2t4CZOPfSlHhXB3k",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "aida-c1a69.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "aida-c1a69",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "aida-c1a69.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "175082703442",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:175082703442:web:a15bd2ad19a7cb1e61ed8b",
};

export const firebaseApp =
  getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(firebaseApp);
